/**
 * Code 10 (a): the sold tier the client already knows, as the gate's lane.
 *
 * `AccountDetails.packageType` is `PACKAGE_TYPE_BASIC` / `PACKAGE_TYPE_PRO` (commons/commons.ts) and
 * `isPaidUser()` is the one correct read of "is the plan live" (V2 entitlements first, V1 fallback —
 * `__tests__/is-paid-user.test.ts`). Structural on purpose: this module must stay a leaf like the
 * coordinator (no `request.utils`, no inversify), so `_app.tsx` passes the account in and the
 * coordinator never imports a service.
 */
import { ScheduleTier } from './batch-schedule-gate';

export interface TierSource {
    packageType?: string | null;
    isPaidUser?: () => boolean;
}

export function scheduleTierOf(account: TierSource | null | undefined): ScheduleTier {
    if (!account) return 'FREE';
    let paid = false;
    try { paid = typeof account.isPaidUser === 'function' ? account.isPaidUser() === true : false; } catch { paid = false; }
    if (!paid) return 'FREE';
    const pkg = String(account.packageType ?? '').toUpperCase();
    if (pkg === 'PACKAGE_TYPE_PRO') return 'PRO';
    if (pkg === 'PACKAGE_TYPE_BASIC') return 'BASIC';
    return 'FREE';
}
